'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Overlay } from '@radix-ui/react-dialog';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const DrawerOverlay = forwardRef(({ className, ...props }, ref) => (_jsx(Overlay, { className: cn('fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', className), ...props, ref: ref })));
DrawerOverlay.displayName = Overlay.displayName;
export { DrawerOverlay };
